//=========================== Getter =================================//
/**
 * fungsi untuk mengambil satribut pada cookies yang dicari
 *
 * @param {atribut yang ingin dicari pada atribut cookies} atribute
 */
import moment from 'moment'

export function getAtribute(atribute) {
  var cname = atribute;
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function getJWT(){
  var tes = getAtribute("auth")

  return tes;
}

function base64url(source) {
  var CryptoJS = require("crypto-js")
  // Encode in classical base64
  var encodedSource = CryptoJS.enc.Base64.stringify(source);

  // Remove padding equal characters
  encodedSource = encodedSource.replace(/=+$/, '');

  // Replace characters according to base64url specifications
  encodedSource = encodedSource.replace(/\+/g, '-');
  encodedSource = encodedSource.replace(/\//g, '_');

  return encodedSource;
}


export function createJWT(){
  var CryptoJS = require("crypto-js")
  var header = {
    "alg": "HS256",
    "typ": "JWT"
  }

  var data = {
    "iss": "auth0",
    "client": "web-frontend-siruang",
    "accessTimestamp": moment(Date.now()).format('YYYY-MM-DD HH:mm:ss')
  }

  var secret = "5385491264520413"

  var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  var encodedHeader = base64url(stringifiedHeader);

  var stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
  var encodedData = base64url(stringifiedData);

  var token = encodedHeader + "." + encodedData;
  var signature = CryptoJS.HmacSHA256(token, secret);
  signature = base64url(signature);

  var signedToken = token + "." + signature;

  return signedToken
}


